

import React from 'react';

import Lock from './../../images/tab-images/lock.svg';
import Unlock from './../../images/tab-images/unlock.svg';
import OverviewIcon from './../../images/tab-images/overview.svg';
import StrengthsIcon from './../../images/tab-images/strengths-weak.svg';
import ComboIcon from './../../images/tab-images/combos.svg';
import RelationshipsIcon from './../../images/tab-images/relationships.svg';
import JobsIcon from './../../images/tab-images/jobs.svg';



const ResultsTabs = ({ selectedTab, setSelectedTab, setPremiumModalOpen, isPaid }) => {

    //console.log(isPaid);

    return (
        <>
            <nav className="results-tabs">

                <div className={`results-tab ${selectedTab == "overview" ? "selected" : "unselected"}`} onClick={() => { setSelectedTab('overview') }}>
                    <div className="results-tab-icon-container">
                        <img className="results-tab-icon" src={OverviewIcon} alt="lock" />
                    </div>
                    <h4 className="results-tab-text">
                        Overview
                    </h4>
                    <div>
                        <div className="results-tab-icon" />
                    </div>
                </div>

                <div className={`results-tab ${selectedTab == "strengths" ? "selected" : "unselected"}`} onClick={() => { setSelectedTab('strengths') }}>
                    <div>
                        <img className="results-tab-icon" src={StrengthsIcon} alt="lock" />
                    </div>
                    <h4 className="results-tab-text">
                        Strengths and weaknessess
                    </h4>
                    <div>
                        <div className="results-tab-icon" />
                    </div>
                </div>
                <div className={`results-tab ${selectedTab == "combinations" ? "selected" : "unselected"}`} onClick={() => { setSelectedTab('combinations') }}>
                    <div>
                        <img className="results-tab-icon" src={ComboIcon} alt="lock" />
                    </div>
                    <h4 className="results-tab-text">
                        Facet combinations
                    </h4>
                    <div>
                        <div className="results-tab-icon" />
                    </div>
                </div>
                <div className={`results-tab ${selectedTab == "relationships" ? "selected" : "unselected"}`} onClick={() => {

                    isPaid ?
                        setSelectedTab('relationships')
                        :
                        setPremiumModalOpen(true)
                }
                }>
                    <div>
                        <img className="results-tab-icon" src={RelationshipsIcon} alt="lock" />
                    </div>
                    <h4 className="results-tab-text">
                        Relationships
                    </h4>
                    <div>

                        {(isPaid == true) ?
                            <img className="results-tab-icon" src={Unlock} alt="lock" />
                            :
                            <img className="results-tab-icon" src={Lock} alt="lock" />
                        }
                    </div>
                </div>
                <div className={`results-tab ${selectedTab == "jobs" ? "selected" : "unselected"}`} onClick={() => {

                    isPaid ?
                        setSelectedTab('jobs')
                        :
                        setPremiumModalOpen(true)
                }
                }>
                    <div>
                        <img className="results-tab-icon" src={JobsIcon} alt="lock" />
                    </div>
                    <h4 className="results-tab-text">
                        Jobs
                    </h4>
                    <div>
                        {(isPaid == true) ?
                            <img className="results-tab-icon" src={Unlock} alt="lock" />
                            :
                            <img className="results-tab-icon" src={Lock} alt="lock" />
                        }
                    </div>
                </div>

            </nav>
        </>

    );



}

export default ResultsTabs;